import FeaturedTopicsContainer from "../components/FeaturedTopics/FeaturedTopicsContainer";
import GuideContainer from "../components/Guides/GuideContainer";
import accountManagementArray from "../utils/accountManagementArray";
import billingInformationArray from "../utils/billingInformationArray";
import { isIOSApp } from "../utils/common";
import formatSlug from "../utils/formatSlug";
import gettingStartedArray from "../utils/gettingStartedArray";
import troubleshootingArray from "../utils/troubleshootingArray";

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <div className="row-landing">
        <div className="col-landing">
          <a
            href="/getting-started"
            style={{ textDecoration: "none", color: "black" }}
          >
            <h2 className="help-heading-home">Getting Started</h2>
          </a>
          {gettingStartedArray.slice(0, 5).map((item, key) => {
            const slug = formatSlug(item.title, true, false);
            return (
              <p key={key} className="getting-started-title">
                <a
                  className="getting-started-title"
                  key={key}
                  href={`/getting-started/${slug}`}
                >
                  {item.title}
                </a>
              </p>
            );
          })}
          <p>
            <a href="/getting-started" className="view-all">
              View all articles
            </a>
          </p>
        </div>
        <div className="col-landing">
          <a
            href="/troubleshooting"
            style={{ textDecoration: "none", color: "black" }}
          >
            <h2 className="help-heading-home">Troubleshooting</h2>
          </a>
          {troubleshootingArray.slice(0, 5).map((item, key) => {
            const slug = formatSlug(item.title, true, false);
            return (
              <p key={key} className="getting-started-title">
                <a
                  className="getting-started-title"
                  key={key}
                  href={`/troubleshooting/${slug}`}
                >
                  {item.title}
                </a>
              </p>
            );
          })}
          <p>
            <a href="/troubleshooting" className="view-all">
              View all articles
            </a>
          </p>
        </div>
        <div className="col-landing">
          <a
            href="/account-management"
            style={{ textDecoration: "none", color: "black" }}
          >
            <h2 className="help-heading-home">Account Management</h2>
          </a>
          {accountManagementArray.slice(0, 3).map((item, key) => {
            const slug = formatSlug(item.title, true, false);
            return (
              <p key={key} className="getting-started-title">
                <a
                  className="getting-started-title"
                  key={key}
                  href={`/account-management/${slug}`}
                >
                  {item.title}
                </a>
              </p>
            );
          })}
          <p>
            <a href="/account-management" className="view-all">
              View all articles
            </a>
          </p>
        </div>
        {!isIOSApp &&
          <div className="col-landing">
            <a
              href="/billing-information"
              style={{ textDecoration: "none", color: "black" }}
            >
              <h2 className="help-heading-home">Billing Information</h2>
            </a>
            {billingInformationArray.slice(0, 4).map((item, key) => {
              const slug = formatSlug(item.title, true, false);
              return (
                <p key={key} className="getting-started-title">
                  <a
                    className="getting-started-title"
                    key={key}
                    href={`/billing-information/${slug}`}
                  >
                    {item.title}
                  </a>
                </p>
              );
            })}
            <p>
              <a href="/billing-information" className="view-all">
                View all articles
              </a>
            </p>
          </div>
        }
      </div>
      <div style={{ marginTop: "5%" }}>
        <GuideContainer />
      </div>
      <div style={{ marginTop: "5%" }}>
        <FeaturedTopicsContainer />
      </div>
    </div>
  );
};

export default Home;
